import type { FakeInteractive } from '../../../ui/arche/primitives/Interactives/FakeInteractive';
import type { InteractiveArchetype } from '../../../ui/archetypes/InteractiveArchetype';

import { Context } from '../../../ui/shared/enums/Context';
import { Direction } from '../../../ui/shared/enums/Direction';
import { Size } from '../../../ui/shared/enums/Size';

/**
 * Default configuration for interactive components
 */
export const defaultFakeInteractive: Partial<InteractiveArchetype> = {
  isDisabled: false,
  text: '',
};

/**
 * Placeholder configuration for interactive components, for use in testing or development
 */
export const placeholderInteractiveArchetypeFake: Partial<InteractiveArchetype> = {
  context: Context.Primary, // Using enum for context
  direction: Direction.Right, // Using enum for type safety
  isBlock: false,
  isDisabled: false,
  size: Size.Medium, // Using 'Md' for medium size; adjust as needed
  text: 'Some Descriptive Text',
};
